import { render, staticRenderFns } from "./ContactRequest.vue?vue&type=template&id=3a0f4001"
import script from "./ContactRequest.vue?vue&type=script&lang=js"
export * from "./ContactRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports